import React from 'react';

import { FormOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';

import Messages from 'i18n/messages/home';

export const WIDTH_CONTANT_PANE = 500;

const EditFolderDetail = (props) => {
  const { disabled, setEditFolderVisible } = props;

  const clickEditFolderHandler = () => {
    setEditFolderVisible(true);
  };

  return (
    <>
      <RibbonButton
        size='small'
        icon={<FormOutlined />}
        label={Messages.editFoldersRibbon}
        onClick={clickEditFolderHandler}
        disabled={disabled}
      />
    </>
  );
};

export default EditFolderDetail;
